import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import './OptionButton.scss';
import classNames from 'classnames';

const OptionButton = ({
  id, name, label, intl, icon, subLabel, avatar, notTranslate, desc, onOptionClick, selected, isCheckbox, rtl,
}) => {
  const classes = classNames({
    'nw-button__option': true,
    'nw-button__option--checked': selected && (selected === id || (Array.isArray(selected) && selected.includes(id))),
    'nw-button__option--rtl': rtl,
  });
  // eslint-disable-next-line react/no-danger
  const intlLabel = notTranslate ? (<span dangerouslySetInnerHTML={{ __html: label }} />) : intl.formatMessage({ id: `${label}` });
  // const intlLabel = notTranslate ? label : intl.formatMessage({ id: `${label}` });

  const handleSelection = (e) => {
    e.preventDefault();
    onOptionClick(id, avatar, notTranslate);
  };

  return (
    // eslint-disable-next-line jsx-a11y/label-has-for
    <label htmlFor={id} className={classes} onClick={handleSelection}>
      { isCheckbox
        ? (
          <input
            type="checkbox"
            defaultChecked={selected.indexOf(id) > -1}
            id={id}
          />
        )
        : (
          <input
            type="radio"
            defaultChecked={selected === id}
            name={name}
            id={id}
          />
        )
      }
      {avatar && <img src={`${process.env.PUBLIC_URL}/images/${avatar}`} alt={intlLabel} className="nw-button__option__avatar" />}
      <div className="nw-button__option__detail">
        <span>
          {avatar ? <strong>{intlLabel}</strong> : intlLabel}
          {subLabel && (<FormattedMessage id={subLabel} />)}
        </span>
        {avatar && desc && <span className="nw-button__option__detail__desc">{intl.formatMessage({ id: desc })}</span>}
      </div>
      {icon && <img src={`${process.env.PUBLIC_URL}/images/${icon}`} alt={intlLabel} />}
      <span className="nw-button__option__checkbox" />
    </label>
  );
};

OptionButton.propTypes = {
  /** Radio Id */
  id: PropTypes.string,
  /** Radio name */
  name: PropTypes.string,
  /** Radio label or title */
  label: PropTypes.node,
  /** Radio select function */
  onOptionClick: PropTypes.func,
  /** Optional icon */
  icon: PropTypes.string,
  /** Sub label */
  subLabel: PropTypes.string,
  /** description */
  desc: PropTypes.string,
  /** Translate or not */
  notTranslate: PropTypes.bool,
  /** display avatar/advisor  */
  avatar: PropTypes.string,
  /** is checkbox */
  isCheckbox: PropTypes.bool,
  /** is RTL */
  rtl: PropTypes.bool,
  //
};

OptionButton.defaultProps = {
  id: null,
  name: null,
  label: null,
  onOptionClick: () => {},
  icon: null,
  subLabel: null,
  desc: null,
  notTranslate: true,
  avatar: null,
  isCheckbox: false,
  rtl: false,
};

export default injectIntl(OptionButton);
